module.exports = __webpack_public_path__ + "img/哈欠.381b28f7.gif";